<template>
    <div id="sms-channels">
        <AppBreadCrumb :paths="[{ title: 'PostaCell' }]" :select="true"></AppBreadCrumb>
        <div style="background-color: #ffffff" class="d-flex right-page">
            <div class="ml-3 mt-3" style="flex: 0 0 100%">
                <div class="big-title">{{ $t("message.postaCellChannels") }}</div>
                <div class="channels">
                    <div class="story channel-add" @click="createChannel" :style="{ opacity: channelAddOpacity }">
                        <a-icon type="plus-circle" theme="filled" style="font-size: 30px" />
                        <span class="text-large font-weight-bolder mt-2" style="font-size: 20px; letter-spacing: 2px">
                            {{ $t("whatsappChannel.addChannel") }}
                        </span>
                    </div>
                    <div
                        class="channel-item"
                        v-for="(channel, index) in channels"
                        @click="() => editChannel(channel)"
                        :key="index"
                    >
                        <div class="icon-container">
                            <img src="/static/img/postacell-logo.png" />
                        </div>
                        <div class="name-container">
                            <span class="name">{{ channel.name.toUpperCase() }}</span>
                        </div>

                        <div class="options">
                            <a-dropdown :trigger="['click']" placement="bottomRight">
                                <div class="icon-container ant-dropdown-link" @click="(e) => e.stopPropagation()">
                                    <span class="material-icons">more_horiz</span>
                                </div>
                                <template #overlay>
                                    <a-menu>
                                        <a-menu-item>
                                            <div
                                                class="icon-container"
                                                @click="
                                                    $router.push(`/integrations/sms/postacell/${channel._id}/detail`)
                                                "
                                            >
                                                <md-icon style="margin-right: 10px">edit</md-icon>
                                                <span>{{ $t("message.edit") }}</span>
                                            </div>
                                        </a-menu-item>
                                        <a-menu-item @click="copyChannelId(channel._id)" style="display:flex; gap: 5px">
                                            <i class="material-icons">content_copy</i>
                                            <span>Channel ID Kopyala</span>
                                        </a-menu-item>
                                        <a-menu-item>
                                            <div class="icon-container" @click="showDeleteConfirmation(channel._id)">
                                                <md-icon style="margin-right: 10px">delete</md-icon>
                                                <span>{{ $t("chatbotv2.delete") }}</span>
                                            </div>
                                        </a-menu-item>
                                    </a-menu>
                                </template>
                            </a-dropdown>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Modal2
            :title="$t('message.newPostaCellChannel')"
            :description="$t('message.createNewPostaCellChannel')"
            class-name="new-sms-postacell"
            :showFooter="false"
            @cancel="showCreateForm = false"
            v-if="showCreateForm"
        >
            <NewChannel @cancel="showCreateForm = false" @ok="showCreateForm = false" />
        </Modal2>
        <Modal2
            :title="$t('message.updateChannel')"
            :description="$t('message.updateChannelDesc4')"
            class-name="new-sms-postacell"
            :showFooter="false"
            @cancel="updatingChannel = null"
            v-if="updatingChannel"
        >
            <UpdateWhatsappBusinessChannel
                @cancel="updatingChannel = false"
                @ok="updatingChannel = false"
                :channel="updatingChannel"
            />
        </Modal2>
        <a-modal
            :visible="deleteModal"
            icon="exclamation-circle"
            :title="$t('whatsappChannel.smsChannel')"
            @cancel="deleteModal = false"
        >
            <p>{{ $t("whatsappChannel.deleteSMSChannelDescription") }}</p>
            <template #footer>
                <a-button key="back" @click="deleteModal = false">
                    {{ $t("chatbotv2.dismiss") }}
                </a-button>
                <a-button key="submit" type="danger" @click="deleteSMSChannel">
                    {{ $t("chatbotv2.delete") }}
                </a-button>
            </template>
        </a-modal>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Modal2 from "../../../../../components/common/Modal2.vue";
import UpdateWhatsappBusinessChannel from "../../../WhatsappBusinessGupshup/UpdateGupshupChannel.vue";
import AppBreadCrumb from "../../../../../components/common/AppBreadCrumb.vue";
import NewChannel from "./NewChannel.vue";

export default {
    name: "PostaCellChannels",
    components: {
        UpdateWhatsappBusinessChannel,
        Modal2,
        AppBreadCrumb,
        NewChannel,
    },
    data() {
        return {
            deleteModal: false,
            showCreateForm: false,
            updatingChannel: null,
            deleteChannelId: null,
            maxChannelCount: 0,
            showUpgrade: false,
        };
    },
    computed: {
        ...mapState({
            channels: (state) => state.channel.channels.filter((x) => x.type === "sms-postacell"),
        }),
        smsPostacellChannels() {
            return this.channels.filter((x) => x.type === "sms-postacell");
        },
        channelAddOpacity() {
            return this.smsPostacellChannels.length === 1 ? 0.5 : 1;
        },
    },
    methods: {
        ...mapActions({
            listChannels: "channel/listChannels",
            listStories: "CB/listStories",
            deleteChannel: "channel/deleteChannel",
        }),
        copyChannelId(channelId) {
            navigator.clipboard.writeText(channelId).then(() => {
                this.$message.success("Channel ID kopyalandı");
            }).catch(() => {
                this.$message.error("Channel ID kopyalanamadı");
            });
        },
        showDeleteConfirmation(id) {
            this.deleteModal = true;
            this.deleteChannelId = id;
        },
        createChannel() {
            if (this.smsPostacellChannels.length === 1) {
                this.$message.error(this.$t("whatsappChannel.maxChannelCount"));
                return;
            } else {
                this.showCreateForm = true;
            }
        },
        editChannel(channel) {
            this.$router.push(`/integrations/sms/postacell/${channel._id}/detail/detail/`);
        },
        deleteSMSChannel() {
            this.deleteModal = false;
            this.deleteChannel(this.deleteChannelId);
        },
    },
    mounted() {
        this.listChannels();
        this.listStories();
    },
    beforeDestroy() {},
    watch: {},
};
</script>

<style lang="scss" scoped>
#sms-channels {
    width: 100%;
    min-height: calc(100vh - 50px);
    background: var(--color-bg-default);

    .big-title {
        font-weight: bold;
        font-size: 1.5rem;
        margin: 1rem 0;
    }

    .channels {
        display: flex;
        align-items: flex-start;
        padding-bottom: 1rem;
        flex-wrap: wrap;
        gap: 1rem;

        .story {
            background: #fff;
            border: 1px solid #a4a4a4;
            border-radius: 4px;
            padding: 1rem;
            cursor: pointer;
            transition: all 0.3s ease-in-out;
            width: 280px;
            height: 260px;
            min-width: 250px;
            max-width: 250px;
            margin-top: 10px;

            &:hover {
                border: 1px solid #06a9f3;
            }

            .title {
                margin: 1rem 0;
                font-weight: bold;
            }

            .chatbot-btn {
                border: none;
                background: #fff;
                border-radius: 4px;
                padding: 4px 8px;
                margin: 0;
                min-height: 34px;
                min-width: 34px;
                color: #000;
                display: flex;
                align-items: center;
                box-shadow: none !important;
                text-shadow: none !important;

                span {
                    text-align: left;
                }
            }
        }

        .channel-item {
            position: relative;
            background: #fff;
            border: 1px solid #a4a4a4;
            border-radius: 4px;
            padding: 1rem;
            cursor: pointer;
            transition: all 0.3s ease-in-out;
            width: 280px;
            height: 260px;
            min-width: 250px;
            max-width: 250px;
            text-align: center;
            transition: 500ms;
            margin-top: 10px;

            .web-hook-title {
                word-break: break-all;
            }

            &:hover {
                border: 1px solid #06a9f3;

                span {
                    color: #06a9f3;
                }

                transform: translateY(-10px);
                box-shadow: -4px 22px 11px -5px rgba(0, 0, 0, 0.1);

                .options {
                    .icon-container {
                        i {
                            transform: rotate(360deg);
                            color: #06a9f3;
                        }
                    }
                }
            }

            .icon-container {
                width: 170px;
                height: 70px;
                display: flex;
                margin: 0 auto;
                align-items: center;
                justify-content: center;
                border-radius: 6px;
                margin-top: 69px;
                overflow: hidden;
                position: relative;
                background: #fff;
                padding: 10px;
            }

            .name-container {
                display: flex;
                flex-direction: column;
                gap: 5px;
                font-size: 20px;
                font-weight: bold;
                margin-top: 10px !important;

                .phone {
                    font-size: 14px;
                    font-weight: normal;
                    color: #a4a4a4;
                }
            }

            span {
                margin: 1rem 0;
                margin-top: 10px !important;
                font-weight: bold;
                display: block;
                font-size: 20px;
                transition: 10ms;
            }

            .options {
                position: absolute;
                top: 5px;
                right: 5px;

                .icon-container {
                    background-color: transparent;
                    width: 25px;
                    height: 35px;
                    margin: 0;
                    padding: 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 3px;

                    i {
                        width: 100%;
                        height: 100%;
                        transition: 1s;
                    }
                }
            }
        }

        .channel-add {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: #006cff;
            border-color: #006cff;
            color: #fff;

            i {
                margin: 0;
            }
        }
    }
}
</style>
